import React, { memo } from 'react';
import styled from 'styled-components';

import { LargeDayForecastCardLoadingUI } from './largeDayForecastCardLoadingUI';
import { ChartLoadingView } from './chartLoadingView';

interface LargeDayCardListItemLoadingUIProps {
    cardIndex: number;
}

export const LargeDayCardListItemLoadingUI = memo(({ cardIndex }: LargeDayCardListItemLoadingUIProps) => {
    return (
        <Container>
            <ContentWrapper>
                <LargeDayForecastCardLoadingUI shouldDisplayHourlyLink={cardIndex <= 5} />
            </ContentWrapper>
            <ChartLoadingView />
        </Container>
    );
});

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 184px;
    width: auto;
    height: 216px;
    max-height: 247px;
    background-color: #f9f9f9;
`; 

const Container = styled.li`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 5px;
    margin-bottom: 0;
    height: auto;
    max-height: 520px;
`;